/**
 * External Dependencies
 */
import 'jquery';
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.bundle.min'


import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleFasadListing from './routes/singlelisting';

const routes = new Router({
  common,
  home,
  singleFasadListing,
});

jQuery(document).ready(() => routes.loadEvents());